/*
 * Poster carousels in the event list.
 *
 * The track is a scroll-snap container, so paging is a scroll and swiping is
 * native. This script only wires the arrows and keeps the dots in step — there
 * is no slider library to initialise, which matters on a listing that can hold
 * thirty of these at once.
 */
(function () {
  function slidesOf(carousel) {
    return carousel.querySelectorAll('.event-list__slide');
  }

  function currentIndex(track, slides) {
    if (!slides.length) return 0;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    return Math.min(Math.max(index, 0), slides.length - 1);
  }

  function markDots(carousel, index) {
    const dots = carousel.querySelectorAll('.event-list__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('event-list__dot--current', i === index);
    });
  }

  function step(carousel, delta) {
    const track = carousel.querySelector('.event-list__track');
    const slides = slidesOf(carousel);
    if (!track || slides.length < 2) return;

    const next = (currentIndex(track, slides) + delta + slides.length) % slides.length;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    track.scrollTo({ left: next * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    markDots(carousel, next);
  }

  function setup(carousel) {
    if (carousel.dataset.eventCarouselReady) return;
    carousel.dataset.eventCarouselReady = 'true';

    const track = carousel.querySelector('.event-list__track');
    if (!track) return;

    const prev = carousel.querySelector('[data-event-carousel-prev]');
    const next = carousel.querySelector('[data-event-carousel-next]');

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        step(carousel, -1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        step(carousel, 1);
      });
    }

    // Swiping moves the track without going through step(), so follow the scroll.
    let frame = null;
    track.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          markDots(carousel, currentIndex(track, slidesOf(carousel)));
        });
      },
      { passive: true },
    );
  }

  function setupAll(root) {
    (root || document).querySelectorAll('[data-event-carousel]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAll();
    });
  } else {
    setupAll();
  }

  // Theme editor re-renders a section without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });
})();
